import React from "react";
import { Box, Typography } from "@mui/material";
import DropDown from "../common/Dropdown/Dropdown";
import "./styles.scss";
import { YEARS } from "../../variables/constants";

type BookTablePropTypes = {
  selectedYear: string;
  setSelectedYear: Function;
};

const TableFilters = (props: BookTablePropTypes) => {
  const { selectedYear, setSelectedYear } = props;
  const yearOptions = [
    { value: "All", label: "All" },
    ...YEARS.map((year) => ({
      value: year.toString(),
      label: year.toString(),
    })),
  ];

  return (
    <Box className="heading-row">
      <Typography variant="h5" component="h4">
        Month End History
      </Typography>
      <Box className="filters">
        <DropDown
          val={selectedYear}
          setVal={setSelectedYear}
          options={yearOptions}
          label="Year"
          width="240px"
        />
      </Box>
    </Box>
  );
};

export default TableFilters;
